import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Checkbox, message } from 'antd';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import includes from 'lodash/includes';
import {
  listSpecialities,
  getAssociationsByExternalIds,
  listOwners,
  updateSpecialityAssociations,
} from './actions';
import Styled from './styled';

export function ProductGaragesPage({ sku }) {
  const [showErrors, setShowErrors] = useState(false);

  const [state, setState] = useState({
    garages: [],
    initialCheckedList: [],
    checkedList: [],
    specialityId: '',
    allSpecialities: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await Promise.all([
        listOwners(),
        getAssociationsByExternalIds([sku]),
        listSpecialities(),
      ])
        .then(([garagesData, defaultData, specialitiesData]) =>
          setState((prevState) => ({
            ...prevState,
            garages: garagesData,
            initialCheckedList: get(defaultData[0], 'specialityAssociation', []),
            checkedList: get(defaultData[0], 'specialityAssociation', []),
            specialityId: get(defaultData[0], 'id', ''),
            allSpecialities: specialitiesData,
          }))
        )
        .catch((err) => {
          message.error(err);
        });
      return response;
    };
    fetchData();
  }, [sku]);

  const isChecked = (val, id) => {
    const garage = state.garages.find((g) => g.name === val && g.id === id);
    return includes(
      state.checkedList.map((li) => li.specialityOwnerId),
      garage.id
    );
  };

  const onChange = (e, id) => {
    if (isChecked(e.target.value, id)) {
      setState((prevState) => ({
        ...prevState,
        checkedList: state.checkedList.filter((li) => li.specialityOwnerId !== id),
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        checkedList: state.checkedList.concat({ specialityOwnerId: id }),
      }));
    }
  };

  const onCheckAllChange = (e) => {
    if (e.target.checked) {
      setState((prevState) => ({
        ...prevState,
        checkedList: state.garages.map((g) => ({ specialityOwnerId: g.id })),
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        checkedList: [],
      }));
    }
  };

  const updateGarages = () => {
    const { specialityId, allSpecialities, initialCheckedList, checkedList } = state;
    let spId = specialityId;

    if (!specialityId) {
      spId = get(
        allSpecialities.find((spec) => spec.external_id === sku),
        'id',
        ''
      );
    }

    const removedAssociation = initialCheckedList
      .filter(
        (initial) => !checkedList.find((current) => initial.specialityOwnerId === current.specialityOwnerId)
      )
      .map((initial) => ({
        associationId: initial.associationId,
        specialityId: spId,
        specialityOwnerId: initial.specialityOwnerId,
      }));

    const newAssociations = checkedList
      .filter(
        (current) =>
          !initialCheckedList.find((initial) => initial.specialityOwnerId === current.specialityOwnerId)
      )
      .map((current) => ({
        specialityId: spId,
        specialityOwnerId: current.specialityOwnerId,
      }));

    if (isEmpty(state.checkedList)) {
      return setShowErrors(true);
    }
    setShowErrors(false);

    return updateSpecialityAssociations({
      remove: removedAssociation,
      add: newAssociations,
    }).then(() => message.info('Specialities have been updated'));
  };

  if (!state.garages) return null;

  return (
    <Styled>
      <div className="garages">
        {showErrors && (
          <div className="errors">
            <div>Errors</div>
            <div>You need to check at least one garage before saving this work operation</div>
          </div>
        )}

        <Checkbox onChange={onCheckAllChange} checked={state.garages.length === state.checkedList.length}>
          Check all garages
        </Checkbox>

        <div className="line" />

        <div className="group">
          {state.garages.map((g) => (
            <Checkbox
              key={g.id}
              value={g.name}
              checked={includes(
                state.checkedList.map((c) => c.specialityOwnerId),
                g.id
              )}
              onChange={(e) => onChange(e, g.id)}
            >
              {g.name}
            </Checkbox>
          ))}
        </div>

        <Button onClick={updateGarages}>Save</Button>
      </div>
    </Styled>
  );
}

export default withRouter(ProductGaragesPage);
